import {
  BankAccountsResponse,
  CreditCardAccountsResponse,
} from "../models/AccountDTOs";
import { API_BASE_URL } from "../../../../config/api";

const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

class APIError extends Error {
  public status: number;
  public data: any;

  constructor(message: string, status: number, data?: any) {
    super(message);
    this.name = "APIError";
    this.status = status;
    this.data = data;
  }
}

const getStoredToken = () => {
  try {
    return localStorage.getItem("access_token");
  } catch (error) {
    console.error("Error accessing localStorage:", error);
    return null;
  }
};

export const fetchBankAccounts = async (): Promise<BankAccountsResponse> => {
  const token = getStoredToken();
  if (!token) {
    throw new APIError(
      "No authentication token found",
      HTTP_STATUS.UNAUTHORIZED
    );
  }

  try {
    const response = await fetch(
      `${API_BASE_URL}/api/cashAndBank/bank-accounts`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new APIError(
        errorData.message || `HTTP error! status: ${response.status}`,
        response.status,
        errorData
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof APIError) {
      throw error;
    }
    throw new APIError(
      `Network error: ${
        error instanceof Error ? error.message : "Unknown error"
      }`,
      HTTP_STATUS.INTERNAL_SERVER_ERROR
    );
  }
};

export const fetchCreditCardAccounts =
  async (): Promise<CreditCardAccountsResponse> => {
    const token = getStoredToken();
    if (!token) {
      throw new APIError(
        "No authentication token found",
        HTTP_STATUS.UNAUTHORIZED
      );
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/cashAndBank/credit-card-accounts`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new APIError(
          errorData.message || `HTTP error! status: ${response.status}`,
          response.status,
          errorData
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      if (error instanceof APIError) {
        throw error;
      }
      throw new APIError(
        `Network error: ${
          error instanceof Error ? error.message : "Unknown error"
        }`,
        HTTP_STATUS.INTERNAL_SERVER_ERROR
      );
    }
  };


